import React, { useState } from 'react';
import '../styles/EnvelopeOpening.css';

const EnvelopeOpening = ({ onOpen, bride, groom }) => {
  const [isOpening, setIsOpening] = useState(false);

  const handleClick = () => {
    setIsOpening(true);
    setTimeout(() => {
      onOpen();
    }, 1500);
  };

  return (
    <div className="envelope-container">
      <div className="envelope-background"></div>
      <div className="envelope-content">
        <p className="tap-instruction">Tap to open your invitation</p>
        <div 
          className={`envelope-wrapper ${isOpening ? 'opening' : ''}`}
          onClick={handleClick}
        >
          <div className="envelope">
            <div className="envelope-flap"></div>
            <div className="envelope-body">
              <div className="wax-seal">
                <div className="seal-inner">
                  <span className="seal-text">S & P</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p className="envelope-subtitle">Wedding Invitation</p>
      </div>
    </div>
  );
};

export default EnvelopeOpening;